module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-community@2x-22a20a0c79ac6c5a893e79a8533f85d3.png";